import { Resource } from 'src/app/global/domain/resource.model';
import { ContaTev } from './conta-tev.model';
import { CategoriaDespesa } from './enum/categoria-despesa.enum';
import { FormaPagamentoDespesa } from './enum/forma-pagamento-despesa.enum';
import { SituacaoLancamentoDespesa } from './enum/situacao-lancamento-despesa.enum';
import { TipoDespesa } from './enum/tipo-despesa.enum';

export class LancamentoDespesa extends Resource {
  dataDespesa: Date;
  dataPagamento: Date;
  descricao: string;
  documento: string;
  tipoDespesa: TipoDespesa;
  categoria: CategoriaDespesa;
  formaPagamento: FormaPagamentoDespesa;
  situacao: SituacaoLancamentoDespesa;
  valor: number;

  /** Conta bancária utilizada quando a forma de pagamento é BANCO. */
  contaTev: ContaTev;

  /** Caixa de onde saiu o valor quando a forma de pagamento é CAIXA. */
  caixaId: number;

  postoId: number;
  postoDescricao: string;
  funcionarioId: number;
  funcionarioNome: string;
  usuarioId: number;
  usuarioNome: string;
  dataCadastro: Date;
  observacao: string;
}
